import { gatewayUIForPath } from './entry-route';

// Load only the presentation needed for this route. Company identity is
// resolved by the authenticated bootstrap, never inferred from a bookmark.
const legacy = gatewayUIForPath(location.pathname, location.hash) === 'legacy';
const stylesheet = document.createElement('link');
stylesheet.rel = 'stylesheet';
stylesheet.href = legacy ? '/styles.css' : '/admin.css';
document.head.append(stylesheet);
void (legacy ? import('./main') : import('./admin/app'));
